'use client';
import { useTheme } from '@emotion/react';
import { Box, Stack } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { useComponentSize } from '../../hooks';

type PaginationDotsType = {
    pages: number;
    setSelected: Dispatch<SetStateAction<number>>;
    selected: number;
};

export const PaginationDots = ({ pages, setSelected, selected }: PaginationDotsType) => {
    const theme = useTheme();
    const [stackSize, setStackRef] = useComponentSize();

    const dotWidth = parseInt(theme.spacing(1)) * 3; // Width of a single dot plus margin
    const maxVisibleDots = Math.floor(stackSize.width / dotWidth) - 2;

    const visibleDots = Array.from({ length: Math.min(pages, maxVisibleDots) }, (_, i) => i);

    return (
        <Stack direction={'row'} width={'100%'} justifyContent={'center'} ref={setStackRef}>
            {visibleDots.map((index) => (
                <Box
                    key={index}
                    onClick={() => setSelected(index)}
                    style={{
                        width: theme.spacing(1),
                        height: theme.spacing(1),
                        borderRadius: '100%',
                        backgroundColor: selected === index ? theme.colors.primary : 'grey',
                        margin: theme.spacing(1),
                        cursor: 'pointer'
                    }}
                    flexShrink={0}
                />
            ))}
            {pages > maxVisibleDots && (
                <>
                    <span>...</span>
                    <Box
                        key={pages - 1}
                        onClick={() => setSelected(pages - 1)}
                        style={{
                            width: theme.spacing(1),
                            height: theme.spacing(1),
                            borderRadius: '100%',
                            backgroundColor: selected === pages - 1 ? theme.colors.primary : 'grey',
                            margin: theme.spacing(1),
                            cursor: 'pointer'
                        }}
                    />
                </>
            )}
        </Stack>
    );
};
